import React from "react";
import { Route, Routes } from "react-router-dom";
import { OnboardTenantScreen } from "../screens/onboard/OnboardTenant.screen";
import { OnboardUserScreen } from "../screens/onboard/OnboardUser.screen";
import { OnboardingScreen } from "../screens/onboard/Onboarding.screen";
const OnboardRoutes = () => {
  return /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "",
    element: /*#__PURE__*/React.createElement(OnboardingScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "user",
    element: /*#__PURE__*/React.createElement(OnboardUserScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "tenant",
    element: /*#__PURE__*/React.createElement(OnboardTenantScreen, null)
  }));
};
export { OnboardRoutes };